<template>
  <div class="select-time-container">
    <div class="select-time-row">
      <div class="select-time-control">
        <label class="control-label">Horário</label>
        <Select v-model="time" :options="timeList" />
      </div>
    </div>

    <div class="select-time-row">
      <div class="select-time-control">
        <label class="control-label">Entrada</label>
        <input
          type="text"
          class="form-control"
          v-model="entrada"
          v-mask="'##h##'"
          @keydown="keydownFormatTime"
          @change="update"
          :disabled="inputDisable"
          spellcheck="false"
        />
      </div>
      <div class="select-time-control">
        <label class="control-label">Saida</label>
        <input
          class="form-control"
          v-model="saida"
          v-mask="'##h##'"
          @keydown="keydownFormatTime"
          @change="update"
          :disabled="inputDisable"
          spellcheck="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Select from '@/components/common/Select'
import { mask } from 'vue-the-mask'
import { keydownFormatTime } from '@/utils/events'

export default {
  components: {
    Select
  },
  directives: {
    mask
  },
  props: {
    value: {
      type: Object
    }
  },
  created() {
    this.entrada = this.value.entrada
    this.saida = this.value.saida
  },
  data() {
    return {
      timeList: [
        { label: '08h - 18h', value: '08h00|18h00' },
        { label: '07h - 13h', value: '07h00|13h00' },
        { label: '12h - 18h', value: '12h00|18h00' },
        { label: '07h - 19h', value: '07h00|19h00' },
        { label: '19h - 07h', value: '19h00|07h00' },
        { label: 'Outros', value: 'outros' }
      ],
      time: '',
      entrada: '',
      saida: '',
      inputDisable: true
    }
  },
  watch: {
    time(value) {
      this.inputDisable = value !== 'outros'

      if (value.length === 0 || !this.inputDisable) {
        this.resetTime()
        return
      }

      if (this.inputDisable) {
        const [entrada, saida] = value.split('|')
        this.setTime({ entrada, saida })
      }
    },
    value: {
      handler(value) {
        const { entrada, saida } = value
        if (entrada === '' && saida === '') {
          this.time = ''
        } else if (entrada === '' || saida === '') {
          this.time = 'outros'
        } else {
          const value = `${entrada}|${saida}`
          const timeListValues = this.timeList.map(t => t.value)

          if (timeListValues.includes(value)) {
            this.time = value
          } else {
            this.time = 'outros'
          }
        }
      },
      deep: true
    }
  },
  methods: {
    setTime({ entrada, saida }) {
      this.entrada = this.formatTime(entrada)
      this.saida = this.formatTime(saida)
      this.update()
    },
    formatTime(time) {
      if (time.length === 0)
      {
        return time
      }

      if (time.length === 2) {
        return `${time}h00`
      }

      return time
    },
    clearTime() {
      this.resetTime()
      this.update()
    },
    resetTime() {
      this.entrada = this.saida = ''
    },
    update() {
      this.entrada = this.formatTime(this.entrada)
      this.saida = this.formatTime(this.saida)

      const { entrada, saida } = this

      if (entrada.length > 0 || saida.length > 0) {
        this.$emit('input', { entrada, saida })
      }
    },
    keydownFormatTime
  }
}
</script>

<style scoped>
.select-time-container {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 600;
  color: #1a202c;
  font-family: BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
}
.select-time-container div.select-time-row {
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.select-time-container div.select-time-control {
  width: 100%;
}
.select-time-container div.select-time-control:not(:first-child) {
  margin-left: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/SelectTime.vue